import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { loadRawEntityDataByIDOrFail } from '@adornis/bh-util/util.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { type TemplateResult } from 'lit';
import type { BHTranslationDictionary } from '../translations/translation.js';
import { Product } from './products.js';
import { User } from './user.js';

@Entity()
export class ProductWaitinglistPriorityRule extends MongoEntity {
  public static override _class = 'ProductWaitinglistPriorityRule';
  public static override _collectionName = 'product-waitinglist-priority-rules';

  @Field(type => String)
  @validate(nonOptional())
  institutionID!: string;

  @Field(type => String)
  productID?: string;

  @DataLoadedField(type => Product, ({ productID }) => productID)
  product: Maybe<Product>;

  hasValue(): boolean {
    throw new Error('this method has to be overwritten');
  }

  renderEditUI(opt: { tr: TranslationController<BHTranslationDictionary> }): TemplateResult<1> {
    throw new Error('this method has to be overwritten');
  }

  async hasHighPriority(userID: string): Promise<boolean> {
    throw new Error('this method has to be overwritten');
  }

  async label(): Promise<[string, string]> {
    throw new Error('this method has to be overwritten');
  }
}

// this class is used for writing tests
@Entity()
export class PriorityTestRule extends ProductWaitinglistPriorityRule {
  static override _class = 'PriorityTestRule' as const;

  override async hasHighPriority(userID: string) {
    const user = await loadRawEntityDataByIDOrFail(User, userID, { email: 1 });
    if (user.email.includes('low')) return false;
    return true;
  }
}
